module.exports = __webpack_public_path__ + "img/page-1.4521efc6.png";